// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PlayOutlineSvg from '@rsuite/icon-font/lib/av/PlayOutline';
var PlayOutline = createSvgIcon({
  as: PlayOutlineSvg,
  ariaLabel: 'play outline',
  category: 'av',
  displayName: 'PlayOutline'
});
export default PlayOutline;